import { m } from "@plannello/i18n/messages";
import { getLocale } from "@plannello/i18n/runtime";
import { copyText } from "@/components/ui";
import { toast } from "@/lib/toast";

/**
 * ROADMAP.md export (GET /products/:key/roadmap.md): the same Markdown the repo docs pull with a
 * token, rendered in the UI language. `view` picks the view the roadmap lists (default: Next up).
 */
async function fetchRoadmap(productKey: string, view?: string): Promise<string> {
  const params = new URLSearchParams({ locale: getLocale() });
  if (view) params.set("view", view);
  const res = await fetch(`/api/v1/products/${encodeURIComponent(productKey)}/roadmap.md?${params}`, {
    credentials: "same-origin",
    headers: { Accept: "text/markdown" },
  });
  if (!res.ok) throw new Error(String(res.status));
  return res.text();
}

export async function copyRoadmap(productKey: string, view?: string): Promise<void> {
  try {
    const md = await fetchRoadmap(productKey, view);
    if (!(await copyText(md))) throw new Error("clipboard");
    toast.show({ title: m.roadmap_copied(), tone: "success" });
  } catch {
    toast.show({ title: m.roadmap_failed(), tone: "danger" });
  }
}

export async function downloadRoadmap(productKey: string, view?: string): Promise<void> {
  try {
    const md = await fetchRoadmap(productKey, view);
    const url = URL.createObjectURL(new Blob([md], { type: "text/markdown;charset=utf-8" }));
    const a = document.createElement("a");
    a.href = url;
    a.download = "ROADMAP.md";
    document.body.append(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  } catch {
    toast.show({ title: m.roadmap_failed(), tone: "danger" });
  }
}
